import { render, staticRenderFns } from "./jiancha.vue?vue&type=template&id=044574ba&scoped=true&"
import script from "./jiancha.vue?vue&type=script&lang=js&"
export * from "./jiancha.vue?vue&type=script&lang=js&"
import style0 from "./jiancha.vue?vue&type=style&index=0&id=044574ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044574ba",
  null
  
)

export default component.exports